import React, { useEffect, useRef } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useUploaderInput } from "components/Pages/Home/Helpers/useUploaderInput.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const EmptyDragAreaComponent = ({ dragged, filesExist }) => {
  const { getTextByKey } = useContent();

  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles } = useUploaderInput({
    filesRef,
    folderRef,
  });

  return (
    <div
      className={`jm-form-uploader-empty-drag-area${dragged ? " dragged" : ""}${
        filesExist ? " files-exist" : ""
      }`}
      onClick={handleAddFiles}
    >
      <Icon name="cloud-upload" />
      {getTextByKey("uploader-dropzone-title-mobile")}
      <div className="hidden-inputs">
        <input type="file" className="files-input" ref={filesRef} multiple />
        <input
          type="file"
          className="folders-input"
          aria-hidden="true"
          webkitdirectory=""
          directory=""
          multiple
          ref={folderRef}
        ></input>
      </div>
    </div>
  );
};

const EmptyDragArea = ({ dragged }) => {
  const { uploaderGetFiles } = useUploader();

  const filesExist = uploaderGetFiles().length > 0;

  return !filesExist || dragged ? (
    <EmptyDragAreaComponent
      {...{
        dragged,
        filesExist,
      }}
    />
  ) : null;
};

export default EmptyDragArea;
